import { API_URL } from "@/_plugins/axios";
import withoutWatchersMixin from "@/_plugins/withoutWatchersMixin";
import debounce from "lodash/debounce";
import Multiselect from "vue-multiselect";
import Form from "@/_plugins/form";
import Pagination from "laravel-vue-pagination";
import HasError from "@/components/HasError";
import i18n from "@/_plugins/i18n";
import DetailsModal from "@/components/DetailsModal";
import { mapGetters } from "vuex";

export default {
  mixins: [withoutWatchersMixin],
  name: "Equipment",
  components: {
    // HelloWorld,
    Multiselect,
    Pagination,
    DetailsModal,
    HasError,
  },
  data() {
    return {
      usersEquipment: [],
      equipmentCategories: [],
      equipmentTypes: [],
      subcategories: [],
      users: [],
      equipment: [],
      deleteId: null,
      item: null,
      requests: {},
      selectedCategory: null,
      selectedEquipmentType: null,
      selectedEquipment: null,
      selectedSubcategory: null,
      form: new Form({
        equipment_user_id: "",
        notes: "",
      }),
      value: null,
      currentPage: 1,
      loading: false,
      deleting: false,
      modalTitle: i18n.tc("requests.add_request"),
      filters: {
        term: "",
      },
    };
  },
  methods: {
    isNew(id) {
      let found = false;
      this.notifications.find((item) => {
        if (item.request_id === id) found = true;
      });
      return found;
    },
    details(i) {
      this.item = i;
      this.$bvModal.show("details");
    },
    setStatusClass(i) {
      switch (i.id) {
        case 1:
          return "waiting";
        case 2:
          return "in-progress";
        case 3:
          return "rejected";
        case 4:
          return "accepted";
      }
    },
    edit(item) {
      this.modalTitle = i18n.tc("equipment.edit_equipment");
      this.item = item;
      this.form.id = item.id;
      this.form.category_id = item.category.id;
      this.form.subcategory_id = item.subcategory.id;
      this.form.equipment_type_id = item.equipment_type.id;
      this.form.category_id = item.category.id;
      this.form.name = item.name;
      this.form.notes = item.notes;
      this.form.quantity = item.quantity;
      this.form.serial_number = item.serial_number;
      this.selectedCategory = item.category;
      this.selectedSubcategory = item.subcategory;
      this.selectedEquipmentType = item.equipment_type;
      this.$bvModal.show("modal-1");
    },
    deleteE(item) {
      this.deleteId = item.id;
      this.$bvModal.show("deleteEquipment");
    },
    deleteEquipment() {
      this.deleting = true;
      API_URL.delete(`equipment/${this.deleteId}`).then(() => {
        this.getAllEquipment();
        this.currentPage = 1;
        this.$toast.success(i18n.tc("notifications.success"));
        this.closeModal();
        this.deleting = false;
      });
    },
    deleteRequest(id) {
      this.loading = true;
      API_URL.delete(`request/${id}`).then(() => {
        this.$toast.success(i18n.tc("notifications.success"));
        this.loading = false;
        this.currentPage = 1;
        this.getMyRequests();
        this.getAllEquipment();
      });
    },
    closeModal() {
      this.$bvModal.hide("details");
      this.form.reset();
      this.form.errors.errors = {};
      this.selectedEquipment = null;
      this.item = null;
    },
    submitForm() {
      this.form
        .post("request")
        .then(() => {
          this.getMyRequests();
          this.getAllEquipment();
          this.$toast.success(i18n.tc("notifications.success"));
          this.$bvModal.hide("modal-1");
          this.closeModal();
        })
        .catch(() => {
          // console.log("ERROR", error.data);
        });
    },
    getAllEquipment() {
      API_URL.get("user-equipment-rented").then((response) => {
        this.equipment = response.data.data;
      });
    },
    getMyRequests() {
      this.loading = true;
      API_URL.get("request", {
        params: {
          page: this.currentPage,
          ...this.filters,
        },
      }).then((response) => {
        this.requests = response.data;
        this.loading = false;
      });
    },
  },
  computed: {
    ...mapGetters({
      notifications: "notifications",
    }),
    resultsCount() {
      return this.requests?.data?.length;
    },
  },
  watch: {
    filters: {
      deep: true,
      immediate: false,
      // eslint-disable-next-line no-unused-vars
      handler: debounce(function (value) {
        this.$withoutWatchers(() => (this.currentPage = 1));
        this.getMyRequests();
      }, 250),
    },
    currentPage() {
      this.getMyRequests();
    },
  },
  mounted() {
    this.getMyRequests();
    this.getAllEquipment();
    this.$emit("loadBreadcrumbLink", {
      pageName: "Moji zahtjevi za popravku postojeće opreme",
    });
  },
};
